/** @prettier */

import 'dayjs/locale/en';
import 'dayjs/locale/nl';
import 'dayjs/locale/fr';
import 'dayjs/locale/de';
import 'dayjs/locale/it';
import 'dayjs/locale/es';
import 'dayjs/locale/el';
import 'dayjs/locale/pl';
import 'dayjs/locale/pt';
import 'dayjs/locale/tr';

//interface import
import * as apiIF from '../Type/api';

/**
 * dayjsを使用しているDatePickerの日付ライブラリ言語を決定する関数
 * @param 言語情報
 * @returns クエリ用言語
 */
const decideDayjsDatePickerLocale = (
  language: apiIF.res.getSettingUser['language']
) => {
  /** datePickerで使用する日付ライブラリ言語 */
  let adapterLocale = 'en';

  //言語設定によってdatePickerに設定するlocal情報を決定する
  switch (language) {
    case 'english':
    default:
      adapterLocale = 'en';
      break;
    case 'dutch':
      adapterLocale = 'nl';
      break;
    case 'french':
      adapterLocale = 'fr';
      break;
    case 'german':
      adapterLocale = 'de';
      break;
    case 'italian':
      adapterLocale = 'it';
      break;
    case 'spanish':
      adapterLocale = 'es';
      break;
    case 'greek':
      adapterLocale = 'el';
      break;
    case 'polish':
      adapterLocale = 'pl';
      break;
    case 'portuguese':
      adapterLocale = 'pt';
      break;
    case 'turkish':
      adapterLocale = 'tr';
      break;
  }
  return adapterLocale;
};

export {decideDayjsDatePickerLocale};
